import React from 'react';
interface BonusCardProps {
  title: string;
  description: string;
  imageUrl: string;
  number: number;
}
export function BonusCard({
  title,
  description,
  imageUrl,
  number
}: BonusCardProps) {
  return <div className="bg-white rounded-xl overflow-hidden shadow-lg border border-amber-200 flex flex-col h-full transform transition-transform hover:scale-[1.02]" data-id="element-3">
      <div className="relative aspect-square w-full bg-amber-50" data-id="element-4">
        <div className="absolute top-4 left-4 z-10 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold shadow-md" data-id="element-5">
          GRATIS HOY
        </div>
        <img src={imageUrl} alt={`Bono ${number}: ${title}`} className="w-full h-full object-cover" data-id="element-6" />
      </div>
      <div className="p-6 flex-1 flex flex-col" data-id="element-7">
        <div className="text-amber-600 font-bold text-sm tracking-wider uppercase mb-2" data-id="element-8">
          Bono Exclusivo #{number}
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight" data-id="element-9">
          {title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-10">{description}</p>
      </div>
    </div>;
}